export class CartStorage {
  private static KEY = 'Cart';

  static getCart(): any[] {
    try {
      const data = localStorage.getItem(this.KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      console.error('Error parsing Cart', e);
      return [];
    }
  }

  static saveCart(cart: any[]): void {
    localStorage.setItem(this.KEY, JSON.stringify(cart));
  }

  static exists(): boolean {
    return localStorage.getItem(this.KEY) !== null;
  }

  static count(): number {
    return this.getCart().length;
  }

  static add(item: any): void {
    const cart = this.getCart();
    cart.push(item);
    this.saveCart(cart);
  }

  static removeByIndex(index: number): void {
    const cart = this.getCart();

    if (index < 0 || index >= cart.length) {
      console.warn('Índice fuera de rango');
      return;
    }

    cart.splice(index, 1);
    this.saveCart(cart);
  }


  static clear(): void {
    localStorage.removeItem(this.KEY);
  }
}